module.exports = __webpack_public_path__ + "static/media/4.058c0bd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4.png
// module id = 65
// module chunks = 0